(function () {
  function nameMultiRowSliderDots() {
    const dotGroups = document.querySelectorAll('[class*="ai-multi-row__slider-dots"]');

    dotGroups.forEach((group, groupIndex) => {
      const dots = group.querySelectorAll('button[class*="ai-multi-row__slider-dot"]');
      const totalDots = dots.length;

      if (!totalDots) return;

      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', `Slider navigation ${groupIndex + 1}`);

      dots.forEach((dot, dotIndex) => {
        const slideNumber = dotIndex + 1;

        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${slideNumber} of ${totalDots}`);

        if (dot.classList.contains('is-active')) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    });
  }

  function runNowAndAgain() {
    nameMultiRowSliderDots();

    setTimeout(nameMultiRowSliderDots, 250);
    setTimeout(nameMultiRowSliderDots, 750);
    setTimeout(nameMultiRowSliderDots, 1500);
    setTimeout(nameMultiRowSliderDots, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runNowAndAgain);
  } else {
    runNowAndAgain();
  }

  window.addEventListener('load', runNowAndAgain);

  document.addEventListener('shopify:section:load', runNowAndAgain);
  document.addEventListener('shopify:section:select', runNowAndAgain);

  const observer = new MutationObserver(function () {
    nameMultiRowSliderDots();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();